import { render } from "./AboutMeView.vue?vue&type=template&id=dd16ebbc&scoped=true"
import script from "./AboutMeView.vue?vue&type=script&lang=js"
export * from "./AboutMeView.vue?vue&type=script&lang=js"

import "./AboutMeView.vue?vue&type=style&index=0&id=dd16ebbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd16ebbc"]])

export default __exports__